module.exports = {
	"newsletter": {
		"orderTitle": "Subscribe to newsletter",
		"title": "Newsletter",
		"text": "Subscribe to our newsletter and you will be among the first to know our latest news and further information about our upcoming events.",
		"placeholder": "Email address",
		"private": "I am a private customer",
		"business": "I am a business customer",
		"submit": "Submit",
		"success": "Thank you! You'll be hearing from us shortly.",
		"fail": "Subscription failed.",
		"tryAgain": "Try again"
	},
	"footer": {
		"openTitle": "Opening hours",
		"specialHours": "Special hours",
		"privacyPolicy": "Privacy policy",
		"webshopPrivacyPolicy": "B2B Privacy policy",
		"webshopTerms": "Webshop Terms and Conditions",
		"otherTimes": "Other times by agreement"
	},
	"contact": {
		"onlineInvoices": "Online invoices"
	},
	"contactForm": {
		"heading": "Contact us",
		"description": "You can contact us directly by email or telephone or by filling in the form below. We will get back to you as soon as possible!",
		"success": "Thank you! You'll be hearing from us shortly.",
		"fail": "Sending failed. Please try again!",
		"name": "Name",
		"email": "Email",
		"phone": "Phone",
		"message": "Message",
		"restaurant": "Select bakery-eatery",
		"submit": "Send"
	},
	"header": {
		"foodAndDrinks": "Food and drinks",
		"contactUs": "Contact"
	},
	"general": {
		"loadMore": "Load more",
		"giftBtn": "Gifts",
		"bookTable": "Book a table",
		"bookTableHeader": "Table reservations",
		"bookOnline": "Book a table\n(1-12 person)",
		"bookFormBtn": "Reservation inquiry\n(over 12 person)",
		"bookOnlinePunavuori": "Book online Punavuori",
		"bookOnlineToolo": "Book online Töölö",
		"businessCard": "Order a business card",
		"giftCard": "Order gift cards",
		"forMedia": "For media",
		"sendRequest": "Send request",
		"oiva": "Oiva report"
	},
	"offerForm": {
		"heading": "Request for an Offer",
		"description": "We want to work hand-in-hand and plan a memorable event. Please submit your request by filling in the form or drop us an email at sales@w-restaurants.fi",
		"premisesHeading": "Premises",
		"premisesDescription": "Leave a brief description of your premises and the kitchen.",
		"dishesHeading": "Do you need dishes?",
		"dishesYes": "Yes",
		"dishesNo": "No",
		"activityHeading": "Program Services",
		"activityDescription": "If you are looking for out of the box experiences, you can always trust in our program services.",
		"activityCocktailSchool": "Cocktail-school",
		"activitySakeTasting": "Sake-tasting",
		"activityWineTasting": "Wine-tasting",
		"budget": "Preliminary budget",
		"name": "Name",
		"company": "Company",
		"email": "Email",
		"phone": "Phone",
		"date": "Date",
		"location": "Location",
		"time": "Time",
		"people": "Number of People",
		"serviceType": "Type of Service",
		"serviceTypeCocktail": "Cocktails with tray service",
		"serviceTypeBuffet": "Buffet",
		"serviceTypeDinner": "Seated Dinner",
		"eventType": "Type of Event",
		"submit": "Send",
		"success": "Thank you for the inquiry, we'll get back to you soonest!",
		"fail": "Sending failed. Please fill all required fields and try again!"
	},
	"groupReservation": {
		"heading": "Reservation inquiry for parties over 10 persons",
		"date": "Date *",
		"time": "Time (between 15:00-22:00)",
		"people": "People",
		"wishes": "Wishes",
		"name": "Name",
		"email": "Email",
		"phone": "Phone",
		"billing": "Billing info and company ID",
		"notice": "Please note that your reservation request is not confirmed until we have confirmed it by return email or by phone. Billing is possible only for companies and organizations. We confirm the possibility for billing when confirming the reservation. Invoicing fee 15 € will be added to the final invoice.",
		"success": "Thank you for the reservation inquiry, we'll get back to you soonest!",
		"fail": "Sending failed. Please try again!"
	},
	"shoppingCart": {
		"heading": "Shopping Cart",
		"emptyCart": "Your cart is empty",
		"totalPrice": "Total",
		"checkout": "Proceed to Checkout"
	},
	"webshop": {
		"addToCart": "Add to cart",
		"chooseValue": "Choose gift card value:"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/lang/en.json
// module id = 1064
// module chunks = 0